import React, { useState } from 'react';
import { AppBar, Toolbar, IconButton, Typography, Button, Box, Menu, MenuItem, Drawer, List, ListItem, ListItemText, Divider, Collapse } from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import MenuIcon from '@mui/icons-material/Menu';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
    const location = useLocation();
    // Estado para la hora actual
    const [dateTime] = useState(new Date());
    const [anchorElTablas, setAnchorElTablas] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    // Estado para el submenú de gráficas
    const [anchorElGraficas, setAnchorElGraficas] = useState(null);
    // Funciones para Drawer móvil
    const [openGraficasDrawer, setOpenGraficasDrawer] = useState(false);
    const [openTablasDrawer, setOpenTablasDrawer] = useState(false);
    const [openParametrosDrawer, setOpenParametrosDrawer] = useState(false);
    const [openProgramacionDrawer, setOpenProgramacionDrawer] = useState(false);
    const [anchorElProgramacion, setAnchorElProgramacion] = useState(null);
    const toggleDrawer = (open) => {
        setDrawerOpen(open);
    };

    const handleMenuOpenTablas = (event) => {
        setAnchorElTablas(event.currentTarget);
    };
    const handleMenuCloseTablas = () => {
        setAnchorElTablas(null);
    };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    return (
        <AppBar position="fixed">
            <Toolbar>
                {/* Botón menú hamburguesa solo visible en móvil */}
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    sx={{ mr: 2, display: { xs: 'flex', md: 'none' } }}
                    onClick={() => toggleDrawer(true)}
                >
                    <MenuIcon />
                </IconButton>
                <Box
                    component={Link}
                    to="/"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        textDecoration: 'none',
                        color: 'inherit',
                        flexGrow: 1,
                    }}
                >
                    <Box
                        component="img"
                        src="/digitalCaratula.webp"
                        alt="Logo"
                        sx={{
                            height: { xs: 32, sm: 36, md: 40 },
                            width: 'auto',
                            maxWidth: { xs: 90, sm: 110, md: 120 },
                            marginRight: '10px',
                            objectFit: 'contain',
                            display: 'block',
                        }}
                    />
                    <Typography
                        variant="h6"
                        component="div"
                        sx={{
                            fontFamily: 'Roboto',
                            fontWeight: '200',
                            display: { xs: 'none', sm: 'block' }
                        }}
                    >
                        DataInformation
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{ ml: 3, fontWeight: 'bold', color: '#B8F1FF', display: 'block', fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' } }}
                    >
                        {dateTime.toLocaleTimeString()}
                    </Typography>
                </Box>
                {/* Menú horizontal solo visible en escritorio */}
                <Box sx={{
                    display: { xs: 'none', md: 'flex' },
                    alignItems: 'center',
                    '& .MuiButton-root': {
                        fontFamily: 'Roboto',
                        fontWeight: 400,
                        fontSize: { md: '0.65rem', lg: '0.75rem', xl: '0.875rem' },
                        px: { md: 0.4, lg: 0.8, xl: 1 },
                        minWidth: 'auto',
                        whiteSpace: 'nowrap',
                    }
                }}>
                    <Button color="inherit" component={Link} to="/" sx={{ fontFamily: 'Roboto', fontWeight: '200', color: location.pathname === '/' ? '#ffd600' : 'inherit', borderBottom: location.pathname === '/' ? '2px solid #ffd600' : 'none' }}>
                        Home
                    </Button>
                    <Button color="inherit" component={Link} to="/login" sx={{ fontFamily: 'Roboto', fontWeight: '200', color: location.pathname === '/login' ? '#ffd600' : 'inherit', borderBottom: location.pathname === '/login' ? '2px solid #ffd600' : 'none' }}>
                        Login
                    </Button>
                    <Button color="inherit" component={Link} to="/register" sx={{ fontFamily: 'Roboto', fontWeight: '200', color: location.pathname === '/register' ? '#ffd600' : 'inherit', borderBottom: location.pathname === '/register' ? '2px solid #ffd600' : 'none' }}>
                        Register
                    </Button>
                    <Button color="inherit" component={Link} to="/datos" sx={{ fontFamily: 'Roboto', fontWeight: '400', color: location.pathname === '/datos' ? '#ffd600' : '#95cef0ff', borderBottom: location.pathname === '/datos' ? '2px solid #ffd600' : 'none' }}>
                        Tablero principal
                    </Button>
                    <Button
                        color="inherit"
                        sx={{ fontFamily: 'Roboto', fontWeight: '200' }}
                        onClick={e => setAnchorElGraficas(e.currentTarget)}
                    >
                        Gráficas
                    </Button>
                    <Menu
                        anchorEl={anchorElGraficas}
                        open={Boolean(anchorElGraficas)}
                        onClose={() => setAnchorElGraficas(null)}
                    >
                        <MenuItem component={Link} to="/graficas/produccion-maquina" 
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/graficas/produccion-maquina' ? '2px solid #ffd600' : 'none', color: location.pathname === '/graficas/produccion-maquina' ? '#ffd600' : 'inherit' }} 
                            onClick={() => setAnchorElGraficas(null)}>
                            Grafica Maquina Dias
                        </MenuItem>
                        
                        <MenuItem component={Link} to="/graficas/acumulado-machine8" 
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/graficas/acumulado-machine8' ? '2px solid #ffd600' : 'none', color: location.pathname === '/graficas/acumulado-machine8' ? '#ffd600' : 'inherit' }} 
                            onClick={() => setAnchorElGraficas(null)}>
                            Acumulado Rama
                        </MenuItem>
                        <MenuItem component={Link} to="/graficas/amperajes-maquina" 
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/graficas/amperajes-maquina' ? '2px solid #ffd600' : 'none', color: location.pathname === '/graficas/amperajes-maquina' ? '#ffd600' : 'inherit' }} 
                            onClick={() => setAnchorElGraficas(null)}>
                            Amperajes por Máquina
                        </MenuItem>
                        <MenuItem component={Link} to="/graficas/amperaje-maquina-dia" 
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/graficas/amperaje-maquina-dia' ? '2px solid #ffd600' : 'none', color: location.pathname === '/graficas/amperaje-maquina-dia' ? '#ffd600' : 'inherit' }} 
                            onClick={() => setAnchorElGraficas(null)}>
                            Amperaje Máquina Día
                        </MenuItem>
                        <MenuItem component={Link} to="/graficas/maquina-dia"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/graficas/maquina-dia' ? '2px solid #ffd600' : 'none', color: location.pathname === '/graficas/maquina-dia' ? '#ffd600' : 'inherit' }}
                            onClick={() => setAnchorElGraficas(null)}>
                            Grafica Maquina Hora
                        </MenuItem>
                        <MenuItem component={Link} to="/graficas/produccion-referencia"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/graficas/produccion-referencia' ? '2px solid #ffd600' : 'none', color: location.pathname === '/graficas/produccion-referencia' ? '#ffd600' : 'inherit' }}
                            onClick={() => setAnchorElGraficas(null)}>
                            Produccion por Referencia
                        </MenuItem>
                        <MenuItem component={Link} to="/graficas/prueba"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/graficas/prueba' ? '2px solid #ffd600' : 'none', color: location.pathname === '/graficas/prueba' ? '#ffd600' : 'inherit' }}
                            onClick={() => setAnchorElGraficas(null)}>
                            Prueba Sensores
                        </MenuItem>
                    </Menu>
                    <Button color="inherit"
                        sx={{ fontFamily: 'Roboto', fontWeight: '200' }}
                        onClick={handleMenuOpenTablas}
                    >
                        Tablas
                    </Button>
                    <Menu
                        anchorEl={anchorElTablas}
                        open={Boolean(anchorElTablas)}
                        onClose={handleMenuCloseTablas}
                    >
                        <MenuItem component={Link} to="/tabla-promedio-rpm/eficiencia-table"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/tabla-promedio-rpm/eficiencia-table' ? '2px solid #ffd600' : 'none', color: location.pathname === '/tabla-promedio-rpm/eficiencia-table' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Tabla de Eficiencia
                        </MenuItem>
                        <MenuItem component={Link} to="/MaquinasTable"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/MaquinasTable' ? '2px solid #ffd600' : 'none', color: location.pathname === '/MaquinasTable' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Tabla componentes
                        </MenuItem>
                        <MenuItem color="inherit" component={Link} to="/ultimo-acumulado-rpm"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/ultimo-acumulado-rpm' ? '2px solid #ffd600' : 'none', color: location.pathname === '/ultimo-acumulado-rpm' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                           Tabla Acumulado RPM
                        </MenuItem>
                        <MenuItem component={Link} to="/ultimo-acumulado-operarios"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/ultimo-acumulado-operarios' ? '2px solid #ffd600' : 'none', color: location.pathname === '/ultimo-acumulado-operarios' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Tabla Acumulado Operarios
                        </MenuItem>
                        <MenuItem component={Link} to="/tablas/tabla-tenido"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/tablas/tabla-tenido' ? '2px solid #ffd600' : 'none', color: location.pathname === '/tablas/tabla-tenido' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Tabla de Teñido
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/parametros-turnos"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/parametros-turnos' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/parametros-turnos' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Tabla segmentos horas
                        </MenuItem>
                        <MenuItem component={Link} to="/produccion-por-referencia"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/produccion-por-referencia' ? '2px solid #ffd600' : 'none', color: location.pathname === '/produccion-por-referencia' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Producción por Referencia
                        </MenuItem>
                        <MenuItem component={Link} to="/programa-telas"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/programa-telas' ? '2px solid #ffd600' : 'none', color: location.pathname === '/programa-telas' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Programa de Telas
                        </MenuItem>
                        <MenuItem component={Link} to="/tablas/horas-operario"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/tablas/horas-operario' ? '2px solid #ffd600' : 'none', color: location.pathname === '/tablas/horas-operario' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuCloseTablas}>
                            Tabla Horas Operario
                        </MenuItem>
                    </Menu>
                    <Button
                        color="inherit"
                        sx={{ fontFamily: 'Roboto', fontWeight: '200' }}
                        onClick={handleMenuOpen}
                    >
                        PARAMETROS
                    </Button>
                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleMenuClose}
                    >
                        <MenuItem component={Link} to="/maquinas/parametros"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/parametros' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/parametros' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Parámetros de Máquinas
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/parametros/caracteristicas"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/parametros/caracteristicas' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/parametros/caracteristicas' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Características Máquinas Tejduria
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/parametros/tipos"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/parametros/tipos' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/parametros/tipos' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Tipo de Máquina
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/valores-eficiencia"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/valores-eficiencia' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/valores-eficiencia' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Valores de Eficiencia
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/formulario-guardar-turnos"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/formulario-guardar-turnos' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/formulario-guardar-turnos' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Guardar Parámetros de Turnos
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/ingreso-operario"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/ingreso-operario' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/ingreso-operario' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Ingreso de Operarios
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/referencias"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/referencias' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/referencias' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Ingresar Referencia
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/parametros/ingreso-materia-prima"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/parametros/ingreso-materia-prima' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/parametros/ingreso-materia-prima' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Ingreso Materia Prima
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/parametros/cargos"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/parametros/cargos' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/parametros/cargos' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Creación de Cargo
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/parametros/reglas-programacion"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/parametros/reglas-programacion' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/parametros/reglas-programacion' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Reglas de Programación
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/parametros/configuracion-agente"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/parametros/configuracion-agente' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/parametros/configuracion-agente' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Configuración Agente IA Turnos
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/parametros/ausencias-operario"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/parametros/ausencias-operario' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/parametros/ausencias-operario' ? '#ffd600' : 'inherit' }}
                            onClick={handleMenuClose}>
                            Ausencias de Operario
                        </MenuItem>
                    </Menu>
                    {/* Menú PROGRAMACION */}
                    <Button
                        color="inherit"
                        sx={{ fontFamily: 'Roboto', fontWeight: '200' }}
                        onClick={e => setAnchorElProgramacion(e.currentTarget)}
                    >
                        PROGRAMACION
                    </Button>
                    <Menu
                        anchorEl={anchorElProgramacion}
                        open={Boolean(anchorElProgramacion)}
                        onClose={() => setAnchorElProgramacion(null)}
                    >
                        <MenuItem component={Link} to="/maquinas/mantenimiento"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/mantenimiento' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/mantenimiento' ? '#ffd600' : 'inherit' }}
                            onClick={() => setAnchorElProgramacion(null)}>
                            Mantenimiento Maquinaria
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/parametros/cambio-agujas"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/parametros/cambio-agujas' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/parametros/cambio-agujas' ? '#ffd600' : 'inherit' }}
                            onClick={() => setAnchorElProgramacion(null)}>
                            Cambio de Agujas Tejeduria
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/asignar-operarios"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/asignar-operarios' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/asignar-operarios' ? '#ffd600' : 'inherit' }}
                            onClick={() => setAnchorElProgramacion(null)}>
                            Asignar Operarios
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/asignar-referencia"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/asignar-referencia' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/asignar-referencia' ? '#ffd600' : 'inherit' }}
                            onClick={() => setAnchorElProgramacion(null)}>
                            Asignar Referencia
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/asignar-tenido"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/asignar-tenido' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/asignar-tenido' ? '#ffd600' : 'inherit' }}
                            onClick={() => setAnchorElProgramacion(null)}>
                            Asignar Teñido
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/parametros/ingreso"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/parametros/ingreso' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/parametros/ingreso' ? '#ffd600' : 'inherit' }}
                            onClick={() => setAnchorElProgramacion(null)}>
                            Integrar Sensor
                        </MenuItem>
                        <MenuItem component={Link} to="/maquinas/contactos-alarma"
                            sx={{ fontFamily: 'Roboto', fontWeight: '200', borderBottom: location.pathname === '/maquinas/contactos-alarma' ? '2px solid #ffd600' : 'none', color: location.pathname === '/maquinas/contactos-alarma' ? '#ffd600' : 'inherit' }}
                            onClick={() => setAnchorElProgramacion(null)}>
                            Contactos Alarma WhatsApp
                        </MenuItem>
                        <MenuItem component={Link} to="/ia/programacion"
                            sx={{ fontFamily: 'Roboto', fontWeight: 'bold', borderBottom: location.pathname === '/ia/programacion' ? '2px solid #ffd600' : 'none', color: location.pathname === '/ia/programacion' ? '#ffd600' : '#B8F1FF' }}
                            onClick={() => setAnchorElProgramacion(null)}>
                            ✦ Programación IA
                        </MenuItem>                        <MenuItem component={Link} to="/ia/agente-turnos"
                            sx={{ fontFamily: 'Roboto', fontWeight: 'bold', borderBottom: location.pathname === '/ia/agente-turnos' ? '2px solid #ffd600' : 'none', color: location.pathname === '/ia/agente-turnos' ? '#ffd600' : '#B8F1FF' }}
                            onClick={() => setAnchorElProgramacion(null)}>
                            ★ Agente IA Turnos
                        </MenuItem>                    </Menu>
                    <Button color="inherit" component={Link} to="/clima"
                        sx={{ fontFamily: 'Roboto', fontWeight: '200', color: location.pathname === '/clima' ? '#ffd600' : 'inherit', borderBottom: location.pathname === '/clima' ? '2px solid #ffd600' : 'none' }}>
                        🌤 Clima
                    </Button>
                    <Button color="inherit" component={Link} to="/mapa-seguimiento"
                        sx={{ fontFamily: 'Roboto', fontWeight: '200', color: location.pathname === '/mapa-seguimiento' ? '#ffd600' : 'inherit', borderBottom: location.pathname === '/mapa-seguimiento' ? '2px solid #ffd600' : 'none' }}>
                        📍 Mapa Seguimiento
                    </Button>
                </Box>
        </Toolbar>
        {/* Drawer para móvil */}
        <Drawer
            anchor="left"
            open={drawerOpen}
            onClose={() => toggleDrawer(false)}
        >
            <Box
                sx={{ width: 250, backgroundColor: '#222', minHeight: '100vh', p: 2 }}
                role="presentation"
            >
                <List>
                    {/* Home */}
                    <ListItem button component={Link} to="/" onClick={() => toggleDrawer(false)}>
                        <ListItemText primary="Home" sx={{ color: '#e0e0e0' }} />
                    </ListItem>
                    <Divider sx={{ my: 0, borderColor: '#444', borderBottomWidth: 1 }} />
                    {/* Login */}
                    <ListItem button component={Link} to="/login" onClick={() => toggleDrawer(false)}>
                        <ListItemText primary="Login" sx={{ color: '#e0e0e0' }} />
                    </ListItem>
                    <Divider sx={{ my: 0, borderColor: '#444', borderBottomWidth: 1 }} />
                    {/* Register */}
                    <ListItem button component={Link} to="/register" onClick={() => toggleDrawer(false)}>
                        <ListItemText primary="Register" sx={{ color: '#e0e0e0' }} />
                    </ListItem>
                    <Divider sx={{ my: 0, borderColor: '#444', borderBottomWidth: 1 }} />
                    {/* Tablero principal */}
                    <ListItem button component={Link} to="/datos" onClick={() => toggleDrawer(false)}>
                        <ListItemText primary="Tablero principal" sx={{ color: '#e0e0e0' }} />
                    </ListItem>
                    <Divider sx={{ my: 0, borderColor: '#444', borderBottomWidth: 1 }} />
                    {/* Gráficas colapsable */}
                    <ListItem button onClick={() => setOpenGraficasDrawer(!openGraficasDrawer)}>
                        <ListItemText primary="Gráficas" sx={{ color: '#e0e0e0' }} />
                        {openGraficasDrawer ? <ExpandLess sx={{ color: '#e0e0e0' }} /> : <ExpandMore sx={{ color: '#e0e0e0' }} />}
                    </ListItem>
                    <Divider sx={{ my: 0, borderColor: '#444', borderBottomWidth: 1 }} />
                    <Collapse in={openGraficasDrawer} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem button component={Link} to="/graficas/produccion-maquina" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Graficas Maquinas Dias" sx={{ color: '#e0e0e0' }} />
                            </ListItem>                           
                            <ListItem button component={Link} to="/graficas/acumulado-machine8" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Acumulado Rama" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/graficas/amperajes-maquina" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Amperajes por Máquina" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/graficas/amperaje-maquina-dia" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Amperaje Máquina Día" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/graficas/maquina-dia" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Grafica Maquina Hora" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/graficas/produccion-referencia" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Produccion por Referencia" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/graficas/prueba" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Prueba Sensores" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                        </List>
                    </Collapse>
                    <Divider sx={{ my: 0, borderColor: '#444', borderBottomWidth: 1 }} />
                    {/* Tablas colapsable */}
                    <ListItem button onClick={() => setOpenTablasDrawer(!openTablasDrawer)}>
                        <ListItemText primary="Tablas" sx={{ color: '#e0e0e0' }} />
                        {openTablasDrawer ? <ExpandLess sx={{ color: '#e0e0e0' }} /> : <ExpandMore sx={{ color: '#e0e0e0' }} />}
                    </ListItem>
                    <Divider sx={{ my: 0, borderColor: '#444', borderBottomWidth: 1 }} />
                    <Collapse in={openTablasDrawer} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem button component={Link} to="/tabla-promedio-rpm/eficiencia-table" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Tabla de Eficiencia" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/MaquinasTable" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Tabla componentes" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/ultimo-acumulado-rpm" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Tabla Acumulado RPM" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/ultimo-acumulado-operarios" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Tabla Acumulado Operarios" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/tablas/tabla-tenido" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Tabla de Teñido" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/parametros-turnos" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Tabla segmentos horas" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/produccion-por-referencia" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Producción por Referencia" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/programa-telas" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Programa de Telas" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/tablas/horas-operario" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Tabla Horas Operario" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                        </List>
                    </Collapse>
                    <Divider sx={{ my: 0, borderColor: '#444', borderBottomWidth: 1 }} />
                    {/* Parámetros colapsable */}
                    <ListItem button onClick={() => setOpenParametrosDrawer(!openParametrosDrawer)}>
                        <ListItemText primary="Parámetros" sx={{ color: '#e0e0e0' }} />
                        {openParametrosDrawer ? <ExpandLess sx={{ color: '#e0e0e0' }} /> : <ExpandMore sx={{ color: '#e0e0e0' }} />}
                    </ListItem>
                    <Divider sx={{ my: 0, borderColor: '#444', borderBottomWidth: 1 }} />
                    <Collapse in={openParametrosDrawer} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem button component={Link} to="/maquinas/parametros" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Parámetros de Máquinas" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/parametros/caracteristicas" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Características de Máquinas" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/parametros/tipos" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Tipo de Máquina" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/valores-eficiencia" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Valores de Eficiencia" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/formulario-guardar-turnos" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Guardar Parámetros de Turnos" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/ingreso-operario" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Ingreso de Operarios" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/referencias" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Ingresar Referencia" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/parametros/cargos" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Creación de Cargo" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/parametros/reglas-programacion" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Reglas de Programación" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/parametros/configuracion-agente" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Configuración Agente IA Turnos" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/parametros/ausencias-operario" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Ausencias de Operario" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                        </List>
                    </Collapse>
                    <Divider sx={{ my: 0, borderColor: '#444', borderBottomWidth: 1 }} />
                    {/* PROGRAMACION colapsable */}
                    <ListItem button onClick={() => setOpenProgramacionDrawer(!openProgramacionDrawer)}>
                        <ListItemText primary="PROGRAMACION" sx={{ color: '#e0e0e0' }} />
                        {openProgramacionDrawer ? <ExpandLess sx={{ color: '#e0e0e0' }} /> : <ExpandMore sx={{ color: '#e0e0e0' }} />}
                    </ListItem>
                    <Divider sx={{ my: 0, borderColor: '#444', borderBottomWidth: 1 }} />
                    <Collapse in={openProgramacionDrawer} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem button component={Link} to="/maquinas/mantenimiento" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Mantenimiento Maquinaria" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/parametros/cambio-agujas" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Cambio de Agujas Tejeduria" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/asignar-operarios" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Asignar Operarios" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/asignar-referencia" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Asignar Referencia" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/asignar-tenido" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Asignar Teñido" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/parametros/ingreso" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Integrar Sensor" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/maquinas/contactos-alarma" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="Contactos Alarma WhatsApp" sx={{ color: '#e0e0e0' }} />
                            </ListItem>
                            <ListItem button component={Link} to="/ia/programacion" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="✦ Programación IA" sx={{ color: '#ffd600', fontWeight: 'bold' }} />                            </ListItem>
                            <ListItem button component={Link} to="/ia/agente-turnos" sx={{ pl: 4 }} onClick={() => toggleDrawer(false)}>
                                <ListItemText primary="★ Agente IA Turnos" sx={{ color: '#ffd600', fontWeight: 'bold' }} />
                            </ListItem>
                        </List>
                    </Collapse>
                    <Divider sx={{ my: 0, borderColor: '#444', borderBottomWidth: 1 }} />
                    <ListItem button component={Link} to="/clima" onClick={() => toggleDrawer(false)}>
                        <ListItemText primary="🌤 Pronóstico de Tiempo" sx={{ color: '#e0e0e0' }} />
                    </ListItem>
                    <Divider sx={{ my: 0, borderColor: '#444', borderBottomWidth: 1 }} />
                    <ListItem button component={Link} to="/mapa-seguimiento" onClick={() => toggleDrawer(false)}>
                        <ListItemText primary="📍 Mapa Seguimiento" sx={{ color: '#e0e0e0' }} />
                    </ListItem>
                </List>
            </Box>
        </Drawer>
        </AppBar>
    );
};

export default Header;